var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    { attrs: { id: "mfa-validation-modal" }, on: { close: _vm.close } },
    [
      _c("div", { staticClass: "mfa-modal-header" }, [
        _c("h3", { staticClass: "text-bold mb-2" }, [_vm._v("Verify Code")]),
        _vm._v(" "),
        _c("p", { staticClass: "modal-pretext" }, [
          _vm._v(
            '\n\t\t\tEnter the one-time code from "' +
              _vm._s(
                this.configName === "" ? "authenticator app" : this.configName
              ) +
              '" to complete authentication\n\t\t'
          )
        ])
      ]),
      _vm._v(" "),
      _c("OTPInput", {
        attrs: {
          error: _vm.error,
          warning: _vm.warning,
          "state-change-key": _vm.stateChangeKey,
          "submit-button-text": "Continue"
        },
        on: {
          resetErrors: _vm.resetWarningsAndErrors,
          otp: function($event) {
            _vm.otp = $event
          },
          submit: _vm.validateConfigOTP
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }